import React, {FC} from 'react';

import {InteractionTrackingContext} from '../../../../libs/shared/ui/src/interactionTracking/interactionTrackingContext';
import {
  trackComponentInteraction,
  trackContextInteraction,
  trackInteraction,
} from '../../../services/interactionTracking';

const trackers = {
  trackInteraction,
  trackComponentInteraction,
  trackContextInteraction,
};

export const InteractionTrackingProvider: FC = ({children}) => (
  <InteractionTrackingContext.Provider value={trackers}>{children}</InteractionTrackingContext.Provider>
);
